export const storyNames: Array<string> = ['stone_tower', 'commander_astel'];
